<template>
  <div id="app" class="h-full" style="background-color: #e5e9ec">

    <el-container
      v-if="this.globalParameters['test_mode'] == 'active'"
      :class="['test-banner-wrapper', { 'with-sidebar': !isAuthRoute }]"
    >
      <el-alert
        class="alert-container"
        type="success"
        :closable="false"
        effect="dark"
        center
      >
        <template #title>
          <span style="font-size: 15px !important;"> {{ i18nValues["test_mode"] }}</span>
        </template>
      </el-alert>
    </el-container>

    <el-container :class="['h-full', 'layout-shell', { 'without-sidebar': isAuthRoute }]">
      <!-- Nav intermedio/full - No Mobile -->
      <div
        v-show="$route.name != 'login' && $route.name != 'error'"
        class="hidden-xs-only"
      >
        <!-- Nav menu full -->
        <div class="hidden-md-and-down height-100">
          <el-aside width="282px" class="height-100" style="overflow-y: auto; overflow-x: visible;">
            <NavMenu
              :menu="menu"
              :subMenu="subMenu"
              :subMenuFieldSite="subMenuFieldSite"
              :subMenuField="subMenuField"
              :subMenuParameters="subMenuParameters"
              :subMenuConfiguration="subMenuConfiguration"
              :collapseBoolean="false"
              v-on:changeHidden="updateHidden($event)"
              v-on:clearFilters="updateClearFilters()"
              class="nav-menu-item"
            />
          </el-aside>
        </div>
        <!-- Nav menu intermedio/chico con bordes blancos-->
        <div class="hidden-lg-and-up height-100">
          <el-aside
            width="64px"
            class="height-100"
            style="display: contents !important"
          >
            <NavMenu
              :menu="menu"
              :subMenu="subMenu"
              :subMenuFieldSite="subMenuFieldSite"
              :subMenuField="subMenuField"
              :subMenuParameters="subMenuParameters"
              :subMenuConfiguration="subMenuConfiguration"
              :collapseBoolean="true"
              v-on:changeHidden="updateHidden($event)"
              v-on:clearFilters="updateClearFilters()"
              class="height-100"
            />
          </el-aside>
        </div>
      </div>
      <!-- Container Header and Menu -->
      <el-container class="h-full">
        <!-- Header intermedio/full - No Mobile -->
        <el-header
          v-show="$route.name != 'login' && $route.name != 'error'"
          class="hidden-xs-only"
          style="height: 48px!important;padding: 0px!important;background-color: #fff;"
        >
          <TopBar
            :fieldSites="fieldSites"
            :campaigns="campaigns"
            :languages="languages"
            v-on:fieldSiteChanged="updateFieldSite($event)"
          ></TopBar>

        </el-header>

        <!-- Header mobile -->
        <el-header
          v-show="$route.name != 'login' && $route.name != 'error'"
          class="hidden-sm-and-up"
          style="background-color: #51b948 !important"
        >
          <NavMenuMobile
            :menu="menu"
            :subMenu="subMenu"
            :subMenuFieldSite="subMenuFieldSite"
            :subMenuField="subMenuField"
            :subMenuParameters="subMenuParameters"
            :subMenuConfiguration="subMenuConfiguration"
            v-on:clearFilters="updateClearFilters($event)"
            v-on:changeHiddenCapaingn="updateHidden($event)"
            ref="ComponentNavMenuMobile"
          ></NavMenuMobile>
        </el-header>

        <!-- Menu principal - All -->
        <el-main class="h-full" style="padding: 20px !important">
          <div class="content h-full">
          
            <el-row :gutter="20" class="h-full">
              <!-- Campaign Table -->
              <el-col
                v-if="$route.name != 'login' && $route.name != 'error'"
                :xs="24"
                :sm="24"
                :md="6"
                :lg="6"
                :xl="6"
              >
              </el-col>
              <!-- Router View -->
              <el-col :xs="24" :sm="24" class="h-full">
                <router-view
                  :componentsMap="profileComponentsMap"
                  @logged="logged"
                  ref="ComponentHome"
                />
              </el-col>
            </el-row>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
  
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import TopBar from "@/components/topBar/TopBar.vue";
import NavMenu from "@/components/nav/NavMenu.vue";
import NavMenuMobile from "@/components/nav/NavMenuMobile.vue";
import { isNull, isNullOrUndefined } from "util"; // eslint-disable-line no-unused-vars
export default {
  name: "app",
  created: function() {
    this.$root.$refs.App = this;
    var vm = this;
    if (!vm.userProfiles && vm.$route.name != "login") {
      vm.$store
        .dispatch("authentication/getUsernameData")
        .then(() => {
          this.retrieveFieldSitesByUserId(vm.user);
          vm.buildComponentsMap().then(function() {
            vm.updatePermissionsGetI18n();
          });
        })
        .catch(function() {
          vm.$cookie.delete("pc_authentication");
          vm.$cookie.delete("identityServerToken");
          vm.$router.push("/login");
        });
    } else {
      vm.buildComponentsMap().then(function() {
        vm.updatePermissionsGetI18n();
      });
    } 
    this.retrieveAllCampaigns();
  },

  components: {
    TopBar,
    NavMenu,
    NavMenuMobile,
  },
  computed: {
    i18nValues: get("i18nStore/valuesRetrieved"),
    //globalParameters: get("config/globalParameters"),
    isAuthRoute() {
      return this.$route.name === "login" || this.$route.name === "error";
    },
  },
  data() {
    return {
      menu: [],
      subMenu: [],
      subMenuFieldSite: [],
      subMenuField: [],
      subMenuParameters: [],
      subMenuConfiguration: [],

      fieldSite: 1,
      fieldSites: [],
      campaigns: [],
      languages: [{ id: "es", name: "Español" }, { id: "en", name: "English" }],
      testMode: false,
    };
  },
  watch: {
    i18nValues: {
      handler() {
        this.updatePermissions(); 
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    logged() {
      var vm = this;
      vm.buildComponentsMap().then(function() {
        vm.updatePermissionsGetI18n();
      });
      let user = vm.$store.state.authentication.user; 
      this.retrieveFieldSitesByUserId(user);
    },
    updatePermissionsGetI18n() {
      var vm = this;
      let i18n = this.$store.get("i18nStore/valuesRetrieved");
      if (i18n && Object.keys(i18n).length > 0) {
        vm.updatePermissions();
      } else {
        // Get the selected language from cookie or store
        var VueCookie = require('vue-cookie');
        const selectedLanguage = VueCookie.get('selectedLanguage') || 
                                 this.$store.get("i18nStore/selectedLanguage") || 
                                 'es';
        // Use changeI18n instead of loadI18n to ensure correct language
        this.$store.dispatch("i18nStore/changeI18n", selectedLanguage).then(() => {
          vm.updatePermissions();
        });
      }
    },

    retrieveFieldSites() {
      this.$store.dispatch("fieldSite/retrieveFieldSites").then((res) => {
        this.fieldSites = res;
      });
    },

    retrieveFieldSitesByUserId(user) {
        let filter = { userId: user.userId }; 
        this.$store.dispatch("fieldSite/retrieveFieldSitesByUserId", filter).then((res) => {
            this.fieldSites = res;
        });
    },

    retrieveAllCampaigns() {
      this.$store.dispatch("campaign/retrieveAllCampaigns").then((res) => {
        this.campaigns = res;
      });
    },

    updatePermissions() {
      var vm = this;
      vm.menu = [];
      vm.subMenu = [];
      vm.subMenuFieldSite = [];
      vm.subMenuField = [];
      vm.subMenuParameters = [];
      vm.subMenuConfiguration = [];

      //Dashboard Menu
      if (vm.profileComponentsMap.get("dashboard")) {
        vm.menu.push({
          href: "/dashboard",
          title: vm.i18nValues["dashboard"],
          icon: "fas fa-chart-line",
        });
      }

      //Looker Dashboard Menu
      if (vm.profileComponentsMap.get("lookerDashboard")) {
        vm.menu.push({
          href: "/lookerDashboard",
          title: vm.i18nValues["generalPlantView"],
          icon: "fas fa-chart-line",
        });
        // New Large Production Looker Dashboard menu
        vm.menu.push({
          href: "/lookerDashboardLargeProduction",
          title: vm.i18nValues["dashboardProduction"],
          icon: "fas fa-chart-bar",
        });
      }

      //FieldSite SubMenu
      if (vm.profileComponentsMap.get("order_menu")) {
        vm.subMenuFieldSite.push({
          href: "/ordersAdmin",
          title: vm.i18nValues["fieldSiteManagement"],
          icon: "fa-solid fa-building-wheat",
          subMenuTwo: [],
        });
      } else if (vm.profileComponentsMap.get("silo_menu")) {
        vm.subMenuFieldSite.push({
          href: "/FieldSection",
          title: vm.i18nValues["fieldSiteManagement"],
          icon: "fa-solid fa-building-wheat",
          subMenuTwo: [],
        });
      }
      

      //LabelManager Menu
      if (vm.profileComponentsMap.get("labelBatch_menu")) {
        vm.subMenuFieldSite[vm.subMenuFieldSite.length - 1].subMenuTwo.push({
          href: "/LabelAdmin",
          title: vm.i18nValues["labels"],
          icon: "fas fa-tag",
        });
      }

      //PalletManager Menu
      if (vm.profileComponentsMap.get("pallet_menu")) {
        vm.subMenuFieldSite[vm.subMenuFieldSite.length - 1].subMenuTwo.push({
          href: "/PalletAdmin",
          title: vm.i18nValues["pallets"],
          icon: "fas fa-search",
        });
      }

      //OrdersManager Menu
      if (vm.profileComponentsMap.get("order_menu")) {
        vm.subMenuFieldSite[vm.subMenuFieldSite.length - 1].subMenuTwo.push({
          href: "/ordersAdmin",
          title: vm.i18nValues["orders"],
          icon: "fa-solid fa-box",
        });
      }

      //I&D Menu
      if (vm.profileComponentsMap.get("researchOrder_menu")) {
        vm.subMenuFieldSite[vm.subMenuFieldSite.length - 1].subMenuTwo.push({
          href: "/researchOrderAdmin",
          title: vm.i18nValues["I&D"],
          icon: "fas fa-flask",
        });
      }

      //ExportManager Menu
      if (vm.profileComponentsMap.get("export_menu")) {
        vm.subMenuFieldSite[vm.subMenuFieldSite.length - 1].subMenuTwo.push({
          href: "/ExportAdmin",
          title: vm.i18nValues["export"],
          icon: "fas fa-file-excel",
        });
      }

      //StockMovementHistory Menu
      if (vm.profileComponentsMap.get("stock_history_menu")) {
        vm.subMenuFieldSite[vm.subMenuFieldSite.length - 1].subMenuTwo.push({
          href: "/stockMovementHistory",
          title: vm.i18nValues["stockHistory"],
          icon: "fas fa-history",
        });
      }

      //StockTransferManager Menu
      if (vm.profileComponentsMap.get("stock_menu")) {
        vm.subMenuFieldSite[vm.subMenuFieldSite.length - 1].subMenuTwo.push({
          href: "/StockTransferAdmin",
          title: vm.i18nValues["palletMovement"],
          icon: "fas fa-cubes-stacked",
        });
      }

      //FieldSectionManager Menu
      if (vm.profileComponentsMap.get("silo_menu")) {
        vm.subMenuFieldSite[vm.subMenuFieldSite.length - 1].subMenuTwo.push({
          href: "/FieldSection",
          title: vm.i18nValues["silos"],
          icon: "fas fa-bars-progress",
        });
      }

      //Field SubMenu
      if (vm.profileComponentsMap.get("product_menu")) {
        vm.subMenuField.push({
          href: "/ProductionAdmin",
          title: vm.i18nValues["fieldManagement"],
          icon:"fa-solid fa-wheat-awn",
          subMenuTwo: [],
        });
      }

      //ProductionManager Menu
      if (vm.profileComponentsMap.get("production_menu")) {
        vm.subMenuField[vm.subMenuField.length - 1].subMenuTwo.push({
          href: "/ProductionAdmin",
          title: vm.i18nValues["productions"],
          icon: "fas fa-parking",
        });
      }

      //Parameters SubMenu
      if (vm.profileComponentsMap.get("product_menu")) {
        vm.subMenuParameters.push({
          href: "/ProductAdmin",
          title: vm.i18nValues["parameterManagement"],
          icon:"fa-regular fa-pen-to-square",
          subMenuTwo: [],
        });
      }

      //ProductManager Menu
      if (vm.profileComponentsMap.get("product_menu")) {
        vm.subMenuParameters[vm.subMenuParameters.length - 1].subMenuTwo.push({
          href: "/ProductAdmin",
          title: vm.i18nValues["products"],
          icon: "fas fa-seedling",
        });
      }

      //EventManager Menu
      if (vm.profileComponentsMap.get("event_menu")) {
        vm.subMenuParameters[vm.subMenuParameters.length - 1].subMenuTwo.push({
          href: "/eventAdmin",
          title: vm.i18nValues["events"],
          icon: "fas fa-cloud-moon",
        });
      }

      //CarrierCompanyManager Menu
      if (vm.profileComponentsMap.get("carrierCompany_menu")) {
        vm.subMenuParameters[vm.subMenuParameters.length - 1].subMenuTwo.push({
          href: "/CarrierCompanyAdmin",
          title: vm.i18nValues["carrierCompany"],
          icon: "fas fa-truck",
        });
      }

      //CustomerManager Menu
      if (vm.profileComponentsMap.get("customer_menu")) {
        vm.subMenuParameters[vm.subMenuParameters.length - 1].subMenuTwo.push({
          href: "/customerAdmin",
          title: vm.i18nValues["customers"],
          icon: "fas fa-users",
        });
      }

      //FieldManager Menu
      if (vm.profileComponentsMap.get("field_menu")) {
        vm.subMenuParameters[vm.subMenuParameters.length - 1].subMenuTwo.push({
          href: "/fieldAdmin",
          title: vm.i18nValues["fields"],
          icon: "fas fa-tractor",
        });
      }

      //FieldSiteManager Menu
      if (vm.profileComponentsMap.get("fieldSite_menu")) {
        vm.subMenuParameters[vm.subMenuParameters.length - 1].subMenuTwo.push({
          href: "/fieldSiteAdmin",
          title: vm.i18nValues["fieldSites"],
          icon: "fas fa-industry",
        });
      }

      //ProducerManager Menu
      if (vm.profileComponentsMap.get("producer_menu")) {
        vm.subMenuParameters[vm.subMenuParameters.length - 1].subMenuTwo.push({
          href: "/producerAdmin",
          title: vm.i18nValues["producers"],
          icon: "fas fa-user-tie",
        });
      }

      //Configuration SubMenu
      if (vm.profileComponentsMap.get("supplier_menu")) {
        vm.subMenuConfiguration.push({
          href: "/supplierAdmin",
          title: vm.i18nValues["configurationManagement"],
          icon:"fa-solid fa-gear",
          subMenuTwo: [],
        });
      }

      //SupplierManager Menu
      if (vm.profileComponentsMap.get("supplier_menu")) {
        vm.subMenuConfiguration[vm.subMenuConfiguration.length - 1].subMenuTwo.push({
          href: "/supplierAdmin",
          title: vm.i18nValues["suppliers"],
          icon: "fas fa-boxes",
        });
      }

      //CampaignManager Menu
      if (vm.profileComponentsMap.get("campaign_menu")) {
        vm.subMenuConfiguration[vm.subMenuConfiguration.length - 1].subMenuTwo.push({
          href: "/campaignAdmin",
          title: vm.i18nValues["campaigns"],
          icon: "fas fa-calendar-alt",
        });
      }

      //VariableManager Menu
      if (vm.profileComponentsMap.get("variable_menu")) {
        vm.subMenuConfiguration[vm.subMenuConfiguration.length - 1].subMenuTwo.push({
          href: "/variableAdmin",
          title: vm.i18nValues["variables"],
          icon: "fas fa-ruler",
        });
      }

      //User Menu
      if (vm.profileComponentsMap.get("user_menu")) {
        vm.subMenuConfiguration[vm.subMenuConfiguration.length - 1].subMenuTwo.push({
          href: "/userAdmin",
          title: vm.i18nValues["users"],
          icon: "fas fa-user",
        });
      }
    },

    updateFieldSite(newFieldSite) {
      this.fieldSite = newFieldSite;
    },
  },
};
</script>

<style>
@import "../node_modules/bootstrap/dist/css/bootstrap.css";
@import "../node_modules/bootstrap-vue/dist/bootstrap-vue.css";
@import "styles/element-ui.scss";
@import "styles/modal.scss";
@import "styles/admin.scss";

#app {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.test-banner-wrapper {
  flex: 0 0 auto;
  box-sizing: border-box !important;
}

/* Align test banner with main content when sidebar is visible */
.test-banner-wrapper.with-sidebar {
  margin-left: 282px !important;
}

/* No margin when sidebar is hidden (login/error pages) */
.test-banner-wrapper:not(.with-sidebar) {
  margin-left: 0 !important;
}

.layout-shell {
  flex: 1 1 auto;
  min-height: 0;
  height: auto !important;
}
.page-container {
  background-color: #e5e9ec;
}
.page-content {
  background-color: #e5e9ec;
  min-height: 100%;
  margin-top: 0;
  padding: 0;
  overflow: visible;
  position: relative;
}
.btn-movil {
  background-color: #3d8b36 !important;
  border: none !important;
  border-radius: 0% !important;
  padding: 0px !important;
  height: 36px;
  width: 36px;
  margin-top: 12px !important;
}
.btn-movil i {
  color: white !important;
  font-size: 16px !important;
}
hr {
  margin-top: 0rem !important;
}
.page-content .content {
  padding-left: 16px !important;
  padding-right: 16px !important;
  padding-top: 10px !important;
}
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9 {
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
#main-grid {
  background-color: white;
}
.main-grid {
  background-color: white;
}
.grid-title h4 {
  display: inline-block;
  font-size: 20px;
  font-weight: 400;
  margin: 0;
  margin-top: 0px;
  padding: 0;
  margin-bottom: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4em !important;
}
.grid.simple {
  padding: 0 !important;
}
.well,
.grid {
  margin-bottom: 10px;
}
.grid {
  clear: both;
  margin-top: 0;
  margin-bottom: 15px;
  padding: 0;
}
.grid.simple .grid-title {
  padding: 15px 15px 0 15px;
  border-bottom: 1px solid #eee;
  color: #282323 !important;
  background-color: #ffffff;
  margin-bottom: 0;
  border: 1px solid #dddddd;
  border-bottom: 0;
  text-align: left;
}
.grid.simple .grid-body {
  background-color: #ffffff;
  padding: 10px 20px 10px;
  border: 1px solid #dddddd;
  color: #6f7b8a;
}
.grid.simple .grid-title.no-border {
  border: 0;
  border-bottom: 0;
}
.grid.simple .grid-body.no-border {
  border: 0;
  padding-top: 25px;
}
/* Remove bold from filter labels */
.filters-row label,
.filters-row /deep/ label,
.filters-row .el-form-item__label,
.filters-row /deep/ .el-form-item__label {
  font-weight: normal !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 10px 0;
  font-family: "Roboto";
  /* font-family: "Montserrat"; */
  font-weight: 300;
  color: #505458;
  border-block-color: #ffffff;
}
.height-100 {
  height: 100% !important;
}

.alert-container {
  color: #ffffff; 
  font-weight: bold; 
  font-size: 16px;
  padding: 26px 12px;
  line-height: 2.1;
}

/* Prevent double scrollbars - ensure only body/html scrolls */
html, body {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Ensure el-main doesn't create its own scrollbar */
.el-main {
  overflow: visible !important;
}

/* Ensure sidebar menu extends full viewport height and stays fixed */
.hidden-md-and-down.height-100 {
  position: fixed !important;
  left: 0;
  top: 0;
  height: 100vh !important;
  width: 282px !important;
  z-index: 1000;
  overflow: visible !important;
  box-sizing: border-box !important;
}

.el-aside {
  height: 100vh !important;
  min-height: 100vh !important;
  width: 282px !important;
  max-width: 282px !important;
  min-width: 282px !important;
  overflow-y: hidden !important;
  overflow-x: visible !important;
  position: relative !important;
  box-sizing: border-box !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* Adjust main content to account for fixed sidebar (282px width) */
.el-container:not(.without-sidebar) > .el-container {
  margin-left: 282px !important;
  box-sizing: border-box !important;
}

.el-container.without-sidebar > .el-container {
  margin-left: 0 !important;
}

/* Ensure the menu background extends full height */
.el-menu-vertical-demo.h-full {
  min-height: 100% !important;
  height: 100% !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

/* Ensure the NavMenu wrapper extends full height */
.nav-menu-item.h-full {
  min-height: 100% !important;
  height: 100% !important;
}

</style>
